import React from "react";
import { ReactComponent as DoneIcon } from "../assets/icon_done.svg";

// Mark-as-done control on the right of a task card, recreating the Android
// TaskItem design: two concentric circles — a 28px outer halo at 30% alpha
// over a 20px solid inner circle (green #5FD788 when done, gray #E2E8F0 when
// pending) — with a white check overlaid when done. Tapping toggles the state.
const DoneToggle = ({ isDone, onToggle }) => {
  const color = isDone ? "#5FD788" : "#E2E8F0";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation(); // don't open the task detail
        onToggle();
      }}
      aria-label={isDone ? "Mark as not done" : "Mark as done"}
      style={{ ...styles.outer, backgroundColor: `${color}4D` }} // 4D ≈ 30% alpha
    >
      <div style={{ ...styles.inner, backgroundColor: color }}>
        {isDone && <DoneIcon style={styles.check} />}
      </div>
    </button>
  );
};

const styles = {
  outer: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    border: "none",
    padding: 0,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  inner: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  check: {
    width: "16px",
    height: "16px",
    filter: "brightness(0) invert(1)", // force the check to white
  },
};

export default DoneToggle;
